import React from "react";
import { Link } from "react-router-dom";
import { FaSearch, FaPaintBrush, FaCode, FaRocket } from "react-icons/fa";
import "./Services.css";

const services = [
  {
    icon: FaSearch,
    title: "Business Discovery",
    description: "We understand your business, customers, and goals to plan the right website.",
  },
  {
    icon: FaPaintBrush,
    title: "UI/UX Design",
    description: "Clean, mobile-friendly designs tailored for shops, salons, clinics, and local brands.",
  },
  {
    icon: FaCode,
    title: "Website Development",
    description: "Fast, secure websites with WhatsApp, Google Maps, contact forms, and SEO basics.",
  },
  {
    icon: FaRocket,
    title: "Launch & Support",
    description: "We deploy your site, connect your domain, and provide ongoing support.",
  },
];

function Services() {
  return (
    <div className="container-fluid" id="fff">
      <div className="container" id="ff">
        <p className="dynamicp" style={{ color: "#35d0f0", fontWeight: "600", textTransform: "uppercase", textAlign: "center" }}>
          Our Services
        </p>
        <h1 className="sub-title1">Everything You Need to Go Online</h1>
        <p className="pp">
          From chai shops to clinics — we build professional websites for 259+ business types across India.
          <br />
          Basic websites from ₹2,500. Advanced, Premium & Enterprise packages available.
        </p>
        <div id="container-block">
          {services.map((service) => (
            <div key={service.title} className="box">
              <service.icon className="service-icon" />
              <h6>{service.title}</h6>
              <p>{service.description}</p>
            </div>
          ))}
        </div>
        <div className="services-cta">
          <Link to="/services" className="services-link-btn" onClick={() => window.scrollTo(0, 0)}>
            See All Services →
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Services;
